import { defineComponent as _defineComponent } from 'vue'
import SizeSelector from 'ah-common-lib/src/common/components/SizeSelector.vue';
import { capitalize } from 'lodash';
import { OutstandingFee } from 'ah-api-gateways/models/feesAndCharges/fees';
import LoadingIcon from 'ah-common-lib/src/icons/components/LoadingIcon.vue';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import {
  defineUseManagedListFilterProps,
  useManagedListFilter,
  UseManagedListFilterEmits,
} from 'ah-common-lib/src/listing';
import { computed, PropType, ref, watch } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhTradesState } from '../..';

interface SingleOwnerOutstandingFeesHeaderEmits extends UseManagedListFilterEmits {}


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleOwnerOutstandingFeesHeader',
  props: {
  ...defineUseManagedListFilterProps(),
  clientOrPartnerId: {
    type: String,
    required: true,
  },
  userType: {
    type: String as PropType<'client' | 'partner'>,
    required: true,
  },
},
  setup(__props, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;

const numberOfRowsOptions: { label: string; value: number }[] = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
  { label: 'All', value: 100000 },
];

const ahTradesState = useAhTradesState();

const requestManager = useRequestManager().manager;

const feesInformation = ref<OutstandingFee[]>([]);





const { sortAndPageData } = useManagedListFilter<{}>({
  props,
  emit,
  filterKeys: [],
  sortAndPageKeys: [
    {
      key: 'pageSize',
      getter: (filters) => filters.value.pageSize || undefined,
      setter: (value, filters) => (filters.value.pageSize = value),
    },
  ],
});

const feesAccrued = computed(() => feesInformation.value.reduce((sum, fee) => sum + fee.feesAccrued, 0));

const feesPaid = computed(() => feesInformation.value.reduce((sum, fee) => sum + fee.feesPaid, 0));

const feesOutstanding = computed(() => feesInformation.value.reduce((sum, fee) => sum + fee.feesOutstanding, 0));

watch(
  () => [props.clientOrPartnerId, props.userType],
  () => {
    feesInformation.value = [];
    const params: any = { type: `${props.userType}s` };
    params[`${props.userType}Id`] = props.clientOrPartnerId;

    requestManager
      .sameOrCancelAndNew(
        `get${capitalize(props.userType)}-${props.clientOrPartnerId}`,
        ahTradesState.services.fees.listOutstandingFees(params)
      )
      .subscribe((response) => (feesInformation.value = response.list));
  },
  { immediate: true }
);

return { __sfc: true,numberOfRowsOptions, ahTradesState, requestManager, feesInformation, emit, props, sortAndPageData, feesAccrued, feesPaid, feesOutstanding, SizeSelector, LoadingIcon, formatCurrencyValue }
}

})